import styled from 'styled-components';

import { spacing } from '../../constants';
import { Button } from '../Button';

interface IProps {
    wrap?: boolean;
}

export const ButtonRow = styled.div<IProps>`
    display: flex;
    flex-wrap: ${({ wrap }) => wrap && 'wrap'};
    width: 100%;
    max-width: 400px;
    padding: 0 20px;

    ${Button} {
        padding: 0;
        width: 100%;

        &:first-child {
            margin-right: ${spacing.lg};
        }
    }
`;
